import { Model } from "@vuex-orm/core";

export default class BizMetrics extends Model {
  static entity = "bizMetrics";

  static fields() {
    return {
      id: this.attr(),
      metricType: this.attr(),
      metricValue: this.attr(),
      createdAt: this.attr(),
      updatedAt: this.attr()
    };
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      updatedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      }
    };
  }
}
